import { STREAM_EVENT_KEYS } from './streamEventKeys';

export const USER_ACTIONS = Object.freeze({
    MOUSE_CLICK: STREAM_EVENT_KEYS.MOUSE_CLICK,
    MOUSE_MOVE: STREAM_EVENT_KEYS.MOUSE_MOVE,
    SCROLL: STREAM_EVENT_KEYS.SCROLL,
    VIEWPORT_RESIZE: STREAM_EVENT_KEYS.VIEWPORT_RESIZE,
    KEY_PRESS: STREAM_EVENT_KEYS.KEY_PRESS,
    SELECT_CHANGE: STREAM_EVENT_KEYS.SELECT_CHANGE,
    INPUT_CHOICE_CHANGE: STREAM_EVENT_KEYS.INPUT_CHOICE_CHANGE,
    CLIPBOARD: STREAM_EVENT_KEYS.CLIPBOARD
});
